'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthAfter.js
// module id = 714
// module chunks = 0